import { WORKBAR_ACTIONS } from '../../constants.js';

const initialWorkBarState = {
  workBarOpen : null,
  workBarRemove : WORKBAR_ACTIONS.NONE,
  workBarAction : WORKBAR_ACTIONS.NONE,
};

const workBarSelected = (state = initialWorkBarState, action) => {
  switch (action.type) {
    case WORKBAR_ACTIONS.INSERT_WINDOW:
      return { workBarOpen : action.componentOpen, workBarAction : WORKBAR_ACTIONS.INSERT_WINDOW};
    case WORKBAR_ACTIONS.REMOVE_WINDOW:
      return { workBarRemove : action.componentRemove, workBarAction : WORKBAR_ACTIONS.REMOVE_WINDOW};
    default:
      return state;
  }
}

export default workBarSelected;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_workBar_selected.js